/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define Error interceptor
 * Remarks:
 *
 * History：
 *      NghiaNX            2021/04/28    Create
 ******************************************************************************/
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../service/authentication.service';
import { LoadingService } from '../../layout/loading/loading.service';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/store/states/app.state';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authSrv: AuthenticationService,
        private loadingSrv: LoadingService,
        private dialog: DialogModalService,
        private trans: TranslateService
        ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            this.loadingSrv.setDisplay(false);
            const error = err.error.message || err.statusText;
            if (err.status === 401) {
                this.handle401Error(request, next);
            } else if (err.status === 0 && err.error instanceof ProgressEvent){
                const msg = this.trans.instant('MESS_ERR_SERVER_TIMEOUT');
                this.dialog.openErrorModal(msg);
            }
            return throwError(error);
        }));
    }
    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        this.authSrv.logout();
    }
}
